import { render, staticRenderFns } from "./siteconfigurationmenu.vue?vue&type=template&id=af0853de&scoped=true"
import script from "./siteconfigurationmenu.vue?vue&type=script&lang=js"
export * from "./siteconfigurationmenu.vue?vue&type=script&lang=js"
import style0 from "./siteconfigurationmenu.vue?vue&type=style&index=0&id=af0853de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0853de",
  null
  
)

export default component.exports